import Layout from "../views/layout/Layout";

export default {
    path: '/propaganda',
    component: Layout,
    redirect: '/propaganda/banner',
    meta: {title: '宣传管理', icon: 'el-icon-s-promotion'},
    children: [{
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/propaganda/banner/index'),
        meta: {title: '横幅管理', icon: 'product-cate'},
        auth: 'propaganda:banner'
    }, {
        path: 'putIn',
        name: 'putIn',
        component: () => import('@/views/propaganda/banner/putIn'),
        meta: {title: '横幅投放审核', icon: 'product-cate'},
        auth: 'propaganda:putIn'
    }, {
        path: 'column',
        name: 'column',
        component: () => import('@/views/propaganda/column/index'),
        meta: {title: '栏目管理', icon: 'product-cate'},
        auth: 'propaganda:column'
    }, {
        path: 'article',
        name: 'article',
        component: () => import('@/views/propaganda/article/index'),
        meta: {title: '文章管理', icon: 'product-cate'},
        auth: 'propaganda:article'
    }]
}



// WEBPACK FOOTER //
// ./src/router/propaganda.js